// ============================
// File: src/features/poc/components/EvidenceUploader.jsx
// ============================
import React, { useRef, useState } from "react";
import { uploadEvidence } from "../api/pocClient";

export function EvidenceUploader({ demandId, checkpointKey, onClose, onUploaded }) {
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState(false);
  const inputRef = useRef(null);

  const onSelect = (e) => setFiles(Array.from(e.target.files || []));

  const onUpload = async () => {
    if (!files.length) return;
    setBusy(true);
    try {
      for (const f of files) {
        const meta = await uploadEvidence(demandId, checkpointKey, f);
        onUploaded?.(meta);
      }
      onClose?.();
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div className="w-full max-w-lg rounded-2xl border border-gray-200 bg-white p-5 shadow-xl">
        <div className="mb-3 flex items-center justify-between">
          <div className="text-base font-semibold text-gray-900">Upload Evidence — {checkpointKey.toUpperCase()}</div>
          <button onClick={onClose} className="text-sm text-gray-500 hover:text-gray-700">Close</button>
        </div>
        <input ref={inputRef} type="file" multiple onChange={onSelect} className="w-full text-sm" />
        {!!files.length && (
          <ul className="mt-3 text-xs text-gray-600 list-disc ml-5">
            {files.map((f) => <li key={f.name}>{f.name} ({Math.round(f.size/1024)} KB)</li>)}
          </ul>
        )}
        <div className="mt-4 flex items-center justify-end gap-2">
          <button onClick={onClose} className="rounded-md border px-3 py-2 text-sm hover:bg-gray-50">Cancel</button>
          <button onClick={onUpload} disabled={busy || !files.length} className="rounded-md bg-indigo-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-60">
            {busy ? "Uploading…" : "Upload"}
          </button>
        </div>
      </div>
    </div>
  );
}